<template>
  <div :class="[getActiveClass, 'nav-item']">
    <router-link v-bind="linkProps(to)">
      <slot></slot>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'AscAppLink',

  props: {
    to: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      activeClass: 'active',
    }
  },

  computed: {
    getActiveClass() {
      const path = this.$route.path
      if (path === '/' && this.to === '/') {
        return 'asc-router-link-active'
      }
      if (path !== '/' && this.to === path) {
        return 'asc-router-link-active'
      }
      if (path !== '/' && path.includes(this.to + '/')) {
        return 'asc-router-link-active'
      }
      return ''
    },
  },

  methods: {
    linkProps(url) {
      if (url.match(/^(http(s)?|ftp):\/\//)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener noreferrer',
        }
      }
      return {
        is: 'router-link',
        to: url,
      }
    },
  },
}
</script>

<style lang="scss">
.surfaceLink {
  a {
    text-decoration: none !important;
  }

  margin-bottom: 16px;
}
</style>
